import script from "./ServiceStatusIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceStatusIndex.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceStatusIndex.vue?vue&type=style&index=0&id=373ea698&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-373ea698"]])

export default __exports__